import PropTypes from 'prop-types'

export const propTypes = {
  className: PropTypes.string,
  isOverlapping: PropTypes.bool
}

export const defaultProps = {}
